import { Injectable } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Address from 'src/app/model/project/address';

@Injectable({
  providedIn: 'root',
})
export class DirectionsCalculationService {
  private directionsService: google.maps.DirectionsService;

  constructor() {
    this.directionsService = new google.maps.DirectionsService();
  }

  public calculateDirections(
    addresses: Address[]
  ): Promise<google.maps.DirectionsResult> {
    if (!CollectionHelper.isPopulated(addresses)) {
      return Promise.resolve(null);
    }
    return new Promise((resolve, reject) => {
      this.directionsService.route(
        this.constructDirectionsRequestBody(addresses),
        (result: google.maps.DirectionsResult, status) => {
          if (status !== google.maps.DirectionsStatus.OK) {
            reject(new Error(`Status not OK: ${status}`));
          } else {
            resolve(result);
          }
        }
      );
    });
  }

  private constructDirectionsRequestBody(addresses: Address[]): RequestBody {
    const start = addresses[0];
    const end = addresses[addresses.length - 1];
    return {
      origin: {
        lat: start.coordinates.lat,
        lng: start.coordinates.lng,
      },
      destination: {
        lat: end.coordinates.lat,
        lng: end.coordinates.lng,
      },
      waypoints: addresses.map((a) => {
        return {
          location: new google.maps.LatLng(
            a.coordinates.lat,
            a.coordinates.lng
          ),
          stopover: true, // setting this to true ensures a route leg actually stops at this waypoint
        };
      }),
      optimizeWaypoints: false, // setting this to false preserves the waypoint order
      travelMode: google.maps.TravelMode.DRIVING,
    };
  }
}

interface RequestBody {
  origin: google.maps.LatLngLiteral;
  destination: google.maps.LatLngLiteral;
  waypoints: google.maps.DirectionsWaypoint[];
  optimizeWaypoints: boolean;
  travelMode: google.maps.TravelMode;
}
